import { Badge, Body1, Body2, makeStyles, Subtitle2, tokens, Tooltip } from '@fluentui/react-components';
import { Tag20Regular, Tag24Regular, TagRegular } from '@fluentui/react-icons';
import { TTag } from '../types';

const useStyles = makeStyles({
  tagBadge: {
    padding: `${tokens.spacingHorizontalL} ${tokens.spacingVerticalM}`,
    backgroundColor: '#c8f2dc',
    color: tokens.colorNeutralForeground1,
    border: `0px solid ${tokens.colorBrandStroke1}`,
  },
  tagIcon: {
    color: tokens.colorBrandForeground2,
  },
});

const TagBadge = ({ tag }: { tag: TTag }) => {
  const classes = useStyles();

  return (
    <Tooltip
      content={'This is a regulatory tag that can be associated to files and sections.'}
      relationship="description"
      positioning="before"
      withArrow
    >
      <Badge icon={<Tag20Regular className={classes.tagIcon} />} appearance="tint" className={classes.tagBadge}>
        <Body1>{tag.name}</Body1>
      </Badge>
    </Tooltip>
  );
};

export default TagBadge;
